// extracted by mini-css-extract-plugin
module.exports = {"circles":"backgroundAnimation-module--circles--3T-F0","animate":"backgroundAnimation-module--animate--3IYAj"};